// Valyuta ro'yxati — Sozlamalar sahifasidagi tanlov uchun.
//
// FAQAT KODLAR saqlanadi. Nom va belgi `Intl` dan olinadi (`lib/format.ts`),
// ya'ni ro'yxat uch tilda o'zi ishlaydi va yangi til qo'shilganda tegilmaydi.
//
// Ro'yxat ISO 4217 ning KENG, lekin to'liq bo'lmagan qismi: tizim turli
// davlatlarda ishlashi mumkin, shuning uchun mintaqa bilan cheklanmadik.
// To'liq ro'yxat (~180 kod) esa tanlashni qiyinlashtirardi va ko'pchiligi
// hech qachon kerak bo'lmasdi. Kerakli kod yo'q bo'lsa qidiruv maydoniga
// qo'lda yozish mumkin — ISO 4217 dagi har qanday kod qabul qilinadi.

/** Eng ehtimolli valyutalar — ro'yxat boshida alohida ko'rsatiladi. */
export const SUGGESTED_CURRENCIES = ['UZS', 'AFN', 'USD', 'EUR', 'RUB'] as const

export const CURRENCY_CODES: string[] = [
  // Markaziy Osiyo va qo'shnilar
  'UZS', 'AFN', 'KZT', 'KGS', 'TJS', 'TMT', 'AZN', 'GEL', 'AMD', 'RUB', 'BYN', 'UAH',
  // Yaqin Sharq
  'AED', 'SAR', 'QAR', 'KWD', 'BHD', 'OMR', 'JOD', 'ILS', 'IQD', 'IRR', 'LBP', 'SYP', 'YER',
  // Janubiy va Sharqiy Osiyo
  'PKR', 'INR', 'BDT', 'LKR', 'NPR', 'CNY', 'JPY', 'KRW', 'HKD', 'TWD',
  'SGD', 'MYR', 'THB', 'IDR', 'PHP', 'VND', 'MNT',
  // Yevropa
  'EUR', 'GBP', 'CHF', 'SEK', 'NOK', 'DKK', 'PLN', 'CZK', 'HUF', 'RON', 'BGN', 'TRY', 'RSD',
  // Amerika
  'USD', 'CAD', 'MXN', 'BRL', 'ARS', 'CLP', 'COP', 'PEN',
  // Afrika
  'EGP', 'ZAR', 'NGN', 'KES', 'TZS', 'UGX', 'ETB', 'MAD', 'DZD', 'TND', 'LYD', 'SDG',
  // Okeaniya
  'AUD', 'NZD',
]

/** Kod ISO 4217 shakliga (uch harf) mos keladimi. */
export function looksLikeCurrencyCode(code: string): boolean {
  return /^[A-Za-z]{3}$/.test(code.trim())
}

export function normalizeCurrencyCode(code: string): string {
  return code.trim().toUpperCase()
}
